module.exports = __webpack_public_path__ + "static/img/hussar_paas_face.74c3e11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/hussar_paas_face.png
// module id = bsGc
// module chunks = 0